import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";

const MobileNavbarAdmin = (props) => {
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const [logo, setLogo] = useState('');

    const getlogo = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss
            }).then(res => {
                setLogo(res.data[0])
            });
        }
        catch (err) {
            console.error("Logo yüklenirken hata oluştu:", err);
        }
    }

    useEffect(() => {
        getlogo();
    }, [])

    return (
        <nav className="navbar navbar-expand-lg bg-white shadow-sm py-2 sticky-top">
            <div className="container-fluid">
                <a className="navbar-brand d-flex align-items-center" href="/">
                    {logo && logo['photo'] ? (
                        <img
                            src={logo['photo']}
                            alt="logo"
                            className="img-fluid"
                            style={{ maxHeight: "45px", objectFit: "contain" }}
                        />
                    ) : (
                        <span className="fw-bold text-primary">LMS Admin</span>
                    )}
                </a>

                <button className="navbar-toggler border-0 shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 mt-3 mt-lg-0">
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t('financialSettings')}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                {/* <li><a className="dropdown-item py-2" href="/admin/bankaccount">{t('bankAccounts')}</a></li> */}
                                <li><a className="dropdown-item py-2" href="/admin/packageprice">{t('packagesAndPrices')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/packagelist">{t('packagesList')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/payment">{t("paymentRequests&newRegister")}</a></li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t('coupensettings')}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/coupenlist">{t('coupenlist')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/createcoupen">{t('createCoupen')}</a></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("individualUserSettings")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                {/* <li><a className="dropdown-item py-2" href="/admin/createusertype">Create User Type</a></li> */}
                                <li><a className="dropdown-item py-2" href="/admin/userlist">{t('userList')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/inactiveusers">Giriş yapmayan kullanıcılar</a></li>
                                {/* <li><a className="dropdown-item py-2" href="/admin/schoollist">{t('schoolList')}</a></li> */}
                                {/* <li><a className="dropdown-item py-2" href="/admin/createschool">{t('createSchool')}</a></li> */}
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("corporateUserSettings")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/schoollist">{t('schoolList')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/createschool">{t('createSchool')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/corporateuserlist">{t('corporateuserList')}</a></li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("tickets")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/searchticket"> {t('searchticket')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/messagemanagement"> Toplu Mesaj Gönder</a></li>
                            </ul>
                        </li>
                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("websiteuser")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createmoderator">{t('createmoderator')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/moderatorlist">{t('moderatorlist')}</a></li>
                            </ul>
                        </li> */}

                        <hr className="my-2 text-muted opacity-25" />

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t('sectionSettings')}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createsection">{t('createSection')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/sectionlist">{t('sectionList')}</a></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t('courseSettings')}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createcourse">{t('createCourse')}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/courselist">{t('courseList')}</a></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("subjectSettings")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createsubject">   {t("createSubject")}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/subjectlist">   {t("subjectList")}</a></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("questionSettings")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createquestion">   {t("createQuestion")}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/questionlist">   {t("questionList")}</a></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle fw-medium" role="button" data-bs-toggle="dropdown" >
                                {t("tagSettings")}
                            </a>
                            <ul className="dropdown-menu border-0 shadow-sm">
                                <li><a className="dropdown-item py-2" href="/admin/createtag">   {t("createTag")}</a></li>
                                <li><a className="dropdown-item py-2" href="/admin/taglist">   {t("tagList")}</a></li>
                            </ul>
                        </li>
                    </ul>

                    <div className="d-flex align-items-center mt-3 mt-lg-0 p-3 p-lg-0 bg-light bg-lg-transparent rounded-3">
                        <a href="/profile" className="d-flex align-items-center text-decoration-none text-dark w-100">
                            <i className="fa fa-user-circle text-primary" style={{ fontSize: "35px" }} aria-hidden="true"></i>
                            <div className="ms-3 lh-sm">
                                <span className="d-block fw-bold text-dark">{user.name}</span>
                                <small className="text-muted text-uppercase fw-medium" style={{ fontSize: "11px" }}>{user.role}</small>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default MobileNavbarAdmin;